"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isZendeskAppVisible = exports.isZapierAppVisible = exports.isThoughtIndustriesAppVisible = exports.isTheLoopsAppVisible = exports.isSkilljarFederatedSearchAppVisible = exports.isSalesforceAppVisible = exports.isProductBoardAppVisible = exports.isIntercomAppVisible = exports.isFreshdeskV2AppVisible = exports.isBiToolsConnectorAppVisible = exports.checkInstallationMap = exports.appsMap = exports.appOrder = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _common = require("@insided/shared/utils/common");

var _constants = require("@insided/shared/constants");

var _once = _interopRequireDefault(require("lodash/once"));

var isZendeskAppVisible = function isZendeskAppVisible() {
  return _common.common.isModuleActive('zendeskFederatedSearch') || _common.common.isModuleActive('zendeskTicketEscalation') || _common.common.isModuleActive('analyticsV2SelfService');
};

exports.isZendeskAppVisible = isZendeskAppVisible;

var isZapierAppVisible = function isZapierAppVisible() {
  return true;
};

exports.isZapierAppVisible = isZapierAppVisible;

var isProductBoardAppVisible = function isProductBoardAppVisible() {
  return _common.common.isModuleActive('productboardIntegration');
};

exports.isProductBoardAppVisible = isProductBoardAppVisible;

var isFreshdeskV2AppVisible = function isFreshdeskV2AppVisible() {
  return _common.common.isModuleActive('freshdeskV2') || _common.common.isModuleActive('freshdeskFederatedSearch');
};

exports.isFreshdeskV2AppVisible = isFreshdeskV2AppVisible;

var isSkilljarFederatedSearchAppVisible = function isSkilljarFederatedSearchAppVisible() {
  return _common.common.isModuleActive('skilljarFederatedSearch');
};

exports.isSkilljarFederatedSearchAppVisible = isSkilljarFederatedSearchAppVisible;

var isSalesforceAppVisible = function isSalesforceAppVisible() {
  return _common.common.isModuleActive('salesforceCrm') || _common.common.isModuleActive('salesforceFederatedSearch') || _common.common.isModuleActive('salesforceCaseEscalation') || _common.common.isModuleActive('salesforceSyncAccountData');
};

exports.isSalesforceAppVisible = isSalesforceAppVisible;

var isThoughtIndustriesAppVisible = function isThoughtIndustriesAppVisible() {
  return _common.common.isModuleActive('thoughtIndustries');
};

exports.isThoughtIndustriesAppVisible = isThoughtIndustriesAppVisible;

var isIntercomAppVisible = function isIntercomAppVisible() {
  return _common.common.isModuleActive('intercomFederatedSearch') || _common.common.isModuleActive('intercomCreateConversations');
};

exports.isIntercomAppVisible = isIntercomAppVisible;

var isTheLoopsAppVisible = function isTheLoopsAppVisible() {
  return _common.common.isModuleActive('theLoops');
};

exports.isTheLoopsAppVisible = isTheLoopsAppVisible;
var isBiToolsConnectorAppVisible = (0, _once.default)(function () {
  return _common.common.isModuleActive('biToolsConnector');
});
exports.isBiToolsConnectorAppVisible = isBiToolsConnectorAppVisible;
var appOrder = ['salesforce', 'zendesk', 'freshdesk', 'skilljar', 'productboard', 'theLoops', 'zapier', 'thoughtindustries', 'intercom', 'tableau', 'looker', 'powerBi', 's3'];
exports.appOrder = appOrder;

var isZendeskAppInstalled = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var res, _res$data, apiToken, subdomain, agentEmail;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _axios.default.get('/integration/zendesk/settings');

          case 3:
            res = _context.sent;
            _res$data = res.data, apiToken = _res$data.apiToken, subdomain = _res$data.subdomain, agentEmail = _res$data.agentEmail;
            return _context.abrupt("return", !!(apiToken && subdomain && agentEmail));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function isZendeskAppInstalled() {
    return _ref.apply(this, arguments);
  };
}();

var isSalesforceAppInstalled = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var res, data;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _axios.default.get('/integration/salesforce/settings', {
              validateStatus: function validateStatus(state) {
                return state >= 200 && state < 300 || state === 403;
              }
            });

          case 3:
            res = _context2.sent;
            data = res.data;

            if (!(Object.keys(data).length === 0)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return", false);

          case 7:
            return _context2.abrupt("return", {
              isInstalled: true,
              authStatus: data.authStatus,
              authStatusDescription: data.authStatusDescription,
              authCodeColor: data.authCodeColor
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", false);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function isSalesforceAppInstalled() {
    return _ref2.apply(this, arguments);
  };
}();

var isFreshdeskAppInstalled = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var res;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _axios.default.get('/integration/freshdeskV2/settings');

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", res.data.isInstalled);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", false);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function isFreshdeskAppInstalled() {
    return _ref3.apply(this, arguments);
  };
}();

var isSkilljarAppInstalled = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    var res;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return _axios.default.get('/integration/skilljar/settings');

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", 'apiToken' in res.data);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", false);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function isSkilljarAppInstalled() {
    return _ref4.apply(this, arguments);
  };
}();

var isProductBoardAppInstalled = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var res;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return _axios.default.get('/integration/productboard/settings');

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", res.data.isInstalled);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", false);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function isProductBoardAppInstalled() {
    return _ref5.apply(this, arguments);
  };
}();

var isZapierAppInstalled = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
    var res;
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return _axios.default.get('/integration/zapier/settings');

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", 'key' in res.data);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", false);

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function isZapierAppInstalled() {
    return _ref6.apply(this, arguments);
  };
}();

var isThoughtIndustriesAppInstalled = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
    var res;
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return _axios.default.get('/integration/thoughtindustries/settings');

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", res.data.isInstalled);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", false);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));

  return function isThoughtIndustriesAppInstalled() {
    return _ref7.apply(this, arguments);
  };
}();

var isIntercomAppInstalled = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
    var res;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return _axios.default.get('/integration/intercom/settings');

          case 3:
            res = _context8.sent;
            return _context8.abrupt("return", res.data.isInstalled);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", false);

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function isIntercomAppInstalled() {
    return _ref8.apply(this, arguments);
  };
}();

var isTheLoopsAppInstalled = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
    var res;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return _axios.default.get('/integration/theloops/details');

          case 3:
            res = _context9.sent;
            return _context9.abrupt("return", res.data.data.status === 'Active');

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", false);

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  return function isTheLoopsAppInstalled() {
    return _ref9.apply(this, arguments);
  };
}();

var isBiToolsConnectorAppInstalled = (0, _once.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
  var res;
  return _regenerator.default.wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return _axios.default.get('/integration/bitoolsconnector/settings');

        case 3:
          res = _context10.sent;
          return _context10.abrupt("return", res.data.isInstalled);

        case 7:
          _context10.prev = 7;
          _context10.t0 = _context10["catch"](0);
          return _context10.abrupt("return", false);

        case 10:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, null, [[0, 7]]);
})));
var appsMap = {
  tableau: {
    isVisible: isBiToolsConnectorAppVisible(),
    title: 'Tableau',
    description: 'Connect Tableau to directly query Communities data, empowering decision-making with seamless and secure integration and robust authentication.',
    imageName: 'tableau-l',
    appLink: '/settings/integrations/bitoolsconnector/tableau',
    isInstalled: false,
    isBeta: false
  },
  looker: {
    isVisible: isBiToolsConnectorAppVisible(),
    title: 'Looker',
    description: 'Connect Looker to directly query Communities data, empowering decision-making with seamless and secure integration and robust authentication.',
    imageName: 'looker-l',
    appLink: '/settings/integrations/bitoolsconnector/looker',
    isInstalled: false,
    isBeta: false
  },
  powerBi: {
    isVisible: isBiToolsConnectorAppVisible(),
    title: 'Power BI',
    description: 'Connect Power BI to directly query Communities data, empowering decision-making with seamless, secure integration and robust authentication.',
    imageName: 'power-bi-l',
    appLink: '/settings/integrations/bitoolsconnector/powerbi',
    isInstalled: false,
    isBeta: false
  },
  s3: {
    isVisible: isBiToolsConnectorAppVisible(),
    title: 'S3',
    description: 'Connect S3 to transfer Communities data to your warehouse, like Snowflake, ensuring enhanced decision-making with seamless, secure integration and robust authentication.',
    imageName: 's3-l',
    appLink: '/settings/integrations/bitoolsconnector/s3',
    isInstalled: false,
    isBeta: false
  },
  zendesk: {
    isVisible: isZendeskAppVisible(),
    title: 'Zendesk',
    description: 'Next-level customer service: create tickets from posts, measure your self-service score, and increase self-service with federated search.',
    imageName: 'zendesk-m',
    appLink: '/settings/integrations/zendesk',
    isInstalled: false
  },
  salesforce: {
    isVisible: isSalesforceAppVisible(),
    title: 'Salesforce',
    description: 'Combine community and CRM data to enable workflows and gain deeper insights, escalate cases from community posts, and enable federated search with Salesforce.',
    imageName: 'salesforce-m',
    appLink: '/settings/integrations/salesforce',
    isInstalled: false
  },
  freshdesk: {
    isVisible: isFreshdeskV2AppVisible(),
    title: 'Freshdesk',
    description: 'Simplify your customer support workflow: escalate tickets and enable federated search with Freshdesk.',
    imageName: 'freshdesk-m',
    appLink: '/settings/integrations/freshdeskV2',
    isInstalled: false
  },
  skilljar: {
    isVisible: isSkilljarFederatedSearchAppVisible(),
    title: 'Skilljar',
    description: "Empower end users to search for Skilljar courses through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    imageName: 'skilljar-m',
    appLink: '/settings/integrations/skilljar',
    isInstalled: false
  },
  productboard: {
    isVisible: isProductBoardAppVisible(),
    title: 'Productboard',
    description: 'Push relevant community posts to Productboard to centralize product feedback for product managers.',
    imageName: 'productboard-m',
    appLink: '/settings/integrations/productboard',
    isInstalled: false
  },
  zapier: {
    isVisible: isZapierAppVisible(),
    title: 'Zapier',
    description: "Connect Gainsight ".concat(_constants.PLATFORM_BRAND_NAME, " to 3,000+ apps with Zapier."),
    imageName: 'zapier-m',
    appLink: '/settings/integrations/zapier',
    isInstalled: false
  },
  thoughtindustries: {
    isVisible: isThoughtIndustriesAppVisible(),
    title: 'Thought Industries',
    description: "Empower end users to search for Thought Industries courses through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    imageName: 'thought-industries-m',
    appLink: '/settings/integrations/thoughtindustries',
    isInstalled: false
  },
  intercom: {
    isVisible: isIntercomAppVisible(),
    title: 'Intercom',
    description: 'Search content from Intercom Help Center. Create intercom conversations from posts. Send incoming messages to Intercom via Zapier integration.',
    imageName: 'intercom-m',
    appLink: '/settings/integrations/intercom',
    isInstalled: false
  },
  theLoops: {
    isVisible: isTheLoopsAppVisible(),
    title: 'TheLoops',
    description: 'Real-time answers: embed TheLoops Agent to provide conversational support on community questions.',
    imageName: 'theloops-l',
    appLink: '/settings/integrations/theloops',
    isInstalled: false
  },
  biToolsConnector: {
    isVisible: isBiToolsConnectorAppVisible(),
    title: 'Data Lake Connector',
    description: 'Access and analyze valuable data from the Gainsight Communities Data Lake by connecting BI tools through a secure connector powered by AWS Athena or easily copying data to preferred data warehouses like Snowflake via S3.',
    imageName: 'data-lake-connector-l',
    appLink: '/settings/integrations/bitoolsconnector',
    isInstalled: false
  }
};
exports.appsMap = appsMap;
var checkInstallationMap = {
  zendesk: isZendeskAppInstalled,
  salesforce: isSalesforceAppInstalled,
  freshdesk: isFreshdeskAppInstalled,
  skilljar: isSkilljarAppInstalled,
  productboard: isProductBoardAppInstalled,
  theLoops: isTheLoopsAppInstalled,
  zapier: isZapierAppInstalled,
  thoughtindustries: isThoughtIndustriesAppInstalled,
  intercom: isIntercomAppInstalled,
  biToolsConnector: isBiToolsConnectorAppInstalled,
  tableau: isBiToolsConnectorAppInstalled,
  looker: isBiToolsConnectorAppInstalled,
  s3: isBiToolsConnectorAppInstalled,
  powerBi: isBiToolsConnectorAppInstalled
};
exports.checkInstallationMap = checkInstallationMap;